import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

class DatePicker extends Component {
  static propTypes = {
    date: PropTypes.object.isRequired,
    displayFormat: PropTypes.string,
    onDateChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    displayFormat: 'DD/MM/YYYY',
  };

  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };
  }

  render() {
    const {
      date, displayFormat, onDateChange, ...props
    } = this.props;
    const { focused } = this.state;
    return (
      <SingleDatePicker
        small
        block={false}
        numberOfMonths={1}
        date={date}
        focused={focused}
        onFocusChange={change => this.setState({ focused: change.focused })}
        onDateChange={onDateChange}
        displayFormat={displayFormat}
        phrases={{
          closeDatePicker: 'Fechar',
          clearDate: 'Limpar',
        }}
        hideKeyboardShortcutsPanel
        {...props}
      />
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/DatePicker.js